module.exports = __webpack_public_path__ + "img/1468698072.b34b73ee.jpg";